import axios from 'axios'

export default {
  getUserInfo (data, cb) {
    axios.post('/core/staff/auth/', null, {headers: {Authorization: 'JWT ' + data}})
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            response.error = true
            cb(response)
          } else {
            cb(response.data)
          }
        } else {
          console.log('auth fail')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 사용자 결제 정보 (포인트, 이용권 만료기간)
  getPricingInfo (cb) {
    axios.get('/biz/company/profile/pricing_info/')
      .then((response) => {
        // 정상적으로 데이터 전송한 경우
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('can`t get pricingInfo!', response)
        }
      })
      .catch((response) => {
        response.error = true
        cb(response)
      })
  },

  getToken (userInfo, cb) {
    // JWT 인증을 위한 토큰 받아오기
    axios.post('/token-auth/', userInfo)
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('auth fail')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  refreshToken (token, cb) {
    // JWT 인증을 위한 토큰 받아오기
    axios.post('/token-refresh/', {token: token})
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('refresh fail')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  verifyToken (token, cb) {
    // JWT 인증을 위한 토큰 받아오기
    axios.post('/token-verify/', {token: token})
      .then(function (response) {
        // 정상적으로 불러온 경우에는
        if (response.status === 200) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('verify fail')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js